import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text } from '@mantine/core';
import styles from './ProductTitle.module.scss';
import { ReactComponent as IconConnected } from '../../../assets/images/icons/icon_connected.svg';

export function ProductTitle() {
  const { t } = useTranslation();
  return (
    <div className={styles.productTitle}>
      {t('ultra_fi_ultra')} <span className={styles.newLabel}>{t('ultra_new')}</span>
    </div>
  );
}

export function ProductTitleDescription() {
  const { t } = useTranslation();
  return <div className={styles.productTitleDescription}>{t('ultra_description')}</div>;
}

/** "Works solo or paired with Fi device" pill shown under the Ultra title/description. */
export function ProductPairingBadge() {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignSelf: 'flex-start',
        alignItems: 'center',
        gap: 8,
        marginBottom: 32,
        padding: '8px 14px',
        borderRadius: 8,
        backgroundColor: '#f4f4f4',
      }}
    >
      <Box
        component={IconConnected}
        aria-hidden={true}
        sx={{
          width: 14,
          height: 14,
          flexShrink: 0,
          display: 'block',
          // icon ships with a hard-coded dark fill; tint it to the secondary grey to match the label
          'path[fill="#100F0E"]': { fill: '#737373' },
        }}
      />
      <Text c="#737373" fz={12} fw={600} lh="140%">
        {t('ultra_works_solo_or_paired_badge')}
      </Text>
    </Box>
  );
}
